import createIcon from '../../createIcon';

/**
 * @component @name PersonRemoveAlt1
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSA4QzEzLjUgNS43OSAxMS43MSA0IDkuNSA0QzcuMjkgNCA1LjUgNS43OSA1LjUgOEM1LjUgMTAuMjEgNy4yOSAxMiA5LjUgMTJDMTEuNzEgMTIgMTMuNSAxMC4yMSAxMy41IDhaTTE2LjUgMTBWMTJIMjIuNVYxMEgxNi41Wk0xLjUgMThWMjBIMTcuNVYxOEMxNy41IDE1LjM0IDEyLjE3IDE0IDkuNSAxNEM2LjgzIDE0IDEuNSAxNS4zNCAxLjUgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonRemoveAlt1 = createIcon('PersonRemoveAlt1', [
  [
    'path',
    {
      d: 'M13.5 8C13.5 5.79 11.71 4 9.5 4C7.29 4 5.5 5.79 5.5 8C5.5 10.21 7.29 12 9.5 12C11.71 12 13.5 10.21 13.5 8ZM16.5 10V12H22.5V10H16.5ZM1.5 18V20H17.5V18C17.5 15.34 12.17 14 9.5 14C6.83 14 1.5 15.34 1.5 18Z',
      key: '1bajrn',
    },
  ],
]);

export default PersonRemoveAlt1;
